import { Injectable } from '@angular/core';
import { collection, CollectionReference } from 'firebase/firestore';
import { CrudService } from '@marmon/frontend/common';
import {
	CreateNotificationDto,
	Notification,
} from '@marmon/shared/types/notification';
import { User } from '@marmon/shared/types/user';
import { BehaviorSubject, firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationApiService extends CrudService<Notification> {
	readonly unreadNotificationCount$ = new BehaviorSubject<number>(0);

	constructor() {
		super('notifications');
		this.setupInitializing();
	}

	override setupInitializing = () =>
		this.user$.subscribe(() => {
			this.reset$.next(true);
			this.initialize();
		});

	override initialize(user: User | null = null) {
		user = user ?? this.user$.value;
		if (!this.path || !user) {
			// reset to initial state
			this.collection = null as any;
			return;
		}

		this.collection = collection(
			this.firestore,
			`users/${user.id}/${this.path}`,
		) as CollectionReference<Notification, Notification>;
	}

	override create(
		_payload: Partial<Notification>,
	): Promise<Partial<Notification>> {
		console.error('Payload not used, invalid operation', _payload);
		throw Error(
			'Invalid operation. Use `send` to create a notification and send it to a user',
		);
	}

	send(payload: CreateNotificationDto, recipient: string) {
		const url = `users/${recipient}/notify`;
		return firstValueFrom(this.http.post(`${this.api}/v1/${url}`, payload));
	}
}
